import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    getAccountDocuments,
    deleteAccountDocument,
} from '../../../../../../actions/accountDetailsActions/documents.actions';
import {toastr} from "react-redux-toastr";
import moment from 'moment';
import axiosInstance from "../../../../../../utils/axios-instance";
import {showModal} from "src/actions/modal.actions";

export class Document extends Component {

    state = {
        isLoading: false,
        isDeleting: false,
    }


    handleViewDocument = () => {
        const {accountId, document} = this.props;

        this.setState({isLoading: true});

        axiosInstance
            .get(`/account/${accountId}/documents/${document.id}`, {
                responseType: 'blob' //Force to receive data in a Blob Format
            })
            .then((response) => {

                this.setState({isLoading: false});

                // Create a Blob from the File Stream
                const file = new Blob([ response.data ], { type: response.data.type });

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file, document.name);
                } else if (navigator.userAgent.match('FxiOS')) {
                    alert('Cannot display on FF iOS');
                } else if (navigator.userAgent.match('CriOS')) {
                    let reader = new FileReader();
                    reader.onloadend = function() {
                        window.open(reader.result);
                    };
                    reader.readAsDataURL(file);
                } else if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
                    let url = window.URL.createObjectURL(file);
                    window.location.href = url;
                } else {
                    // Build a URL from the file
                    const fileURL = URL.createObjectURL(file);

                    // Open the URL on new Window
                    let newWindow = window.open(fileURL, '_blank');

                    // Alert the user of blocked popup
                    if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {

                        let browser = 'Your web browser';

                        if (navigator.userAgent.toLowerCase().indexOf('chrome/') > -1) browser = 'Chrome';
                        else if (navigator.userAgent.toLowerCase().indexOf('safari/') > -1) browser = 'Safari';
                        else if (navigator.userAgent.toLowerCase().indexOf('firefox/') > -1) browser = 'Firefox';

                        toastr.error(browser + ' blocked the file window from opening. Please allow pop ups and try again.', {timeOut: 0, position: 'top-center'});
                    }
                }
            })
            .catch((error, response) => {
                this.setState({isLoading: false});

                if (error.response && error.response.data) {
                    error.response.data.text().then(response => {
                        const resp = JSON.parse(response);
                        let errorMessage = 'Something went wrong';
                        if (resp.error.message) errorMessage = resp.error.message;
                        toastr.error(errorMessage, { timeOut: 2000, position: 'top-center' });
                    });
                }

            });
    }

    handleDeleteDocument = () => {
        const {accountId, document} = this.props;

        toastr.confirm("Are you sure you want to delete "+ document.name +"?", {
            cancelText: "Cancel",
            okText: "Confirm",
            onOk: () => {
                this.setState({isDeleting: true});

                this.props.deleteAccountDocument(accountId, document.id).then(response => {
                    this.setState({isDeleting: false});

                    if (response.success === true) {
                        this.props.getAccountDocuments(accountId);
                        toastr.success(document.name + ' deleted successfully', { timeOut: 2000, position: 'top-center' });
                    } else {
                        let errorMessage = 'Something went wrong';
                        if (response && response.error && response.error.message) errorMessage = response.error.message;
                        toastr.error(errorMessage, { timeOut: 2000, position: 'top-center' });
                    }
                });
            },
            onCancel: () => {
            }
        });
    }

    checkRestriction = (type) => {
        const {document, canViewRestricted, canView, canEdit, canDelete} = this.props
        if(document.restricted && canViewRestricted) {
            return true
        } else {
            switch(type) {
                case 'view':
                return !document.restricted && canView;
                case 'edit':
                    return !document.restricted && canEdit;
                case 'delete':
                    return !document.restricted && canDelete;
                default:
                    return false;
            }
        }
    }


    render() {

        const {
            isLoading,
            isDeleting,
        } = this.state;

        const {
            accountId,
            documentId,
            documentName,
            documentDate,
            documentDescription,
            canDelete,
            canEdit,
            canView,
            canViewRestricted,
            showModal,
            document
        } = this.props;

        return (
            <div className="form-group">
                <div className="form-row">
                    <div className="col">
                        <p className="documents-panel-name">{document.restricted && <i className="fas fa-exclamation-triangle" style={{color:'#e5b93b'}}/>} {document.description || " No description available"}</p>
                    </div>
                    <div className="col-auto">
                        {this.checkRestriction("view") &&
                            <button type="button" className="btn btn-outline-primary"
                                    disabled={isLoading}
                                    onClick={() => this.handleViewDocument()}
                                    title="View"
                            >
                                {isLoading
                                    ? <i className="fas fa-fw fa-spin fa-spinner" />
                                    : <i className="fas fa-fw fa-eye" />
                                }
                            </button>
                        }
                        {this.checkRestriction("edit") &&
                            <button type="button" className="btn btn-outline-primary"
                                    disabled={isLoading}
                                    onClick={() => showModal('ADD_DOCUMENT_MODAL', {type:'edit', accountId: accountId,
                                        document, canViewRestricted})}
                                    title="Edit"
                            >
                                {isLoading
                                    ? <i className="fas fa-fw fa-spin fa-spinner" />
                                    : <i className="fas fa-edit"></i>
                                }
                            </button>
                        }

                        {this.checkRestriction("delete") &&
                            <button type="button" className="btn btn-outline-danger"
                                    disabled={isDeleting}
                                    onClick={() => showModal('ADD_DOCUMENT_MODAL', {type:'delete', accountId: accountId, document})}
                                    title="Delete"

                            >
                                {isDeleting || isLoading
                                    ? <i className="fas fa-fw fa-spin fa-spinner" />
                                    : <i className="fas fa-fw fa-trash-alt" />
                                }
                            </button>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="col">
                        <p className="documents-panel-details">
                            <span><i className="fas fa-calendar-alt" />{moment(document.createdDateTime).format("MM/DD/YYYY")}</span>
                            {document.name &&
                            <span><i className="fas fa-info-circle"/>{document.name}</span>
                            }
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    getAccountDocuments,
    deleteAccountDocument,
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(Document);
